import React, {Component} from 'react';
import {Map, Marker} from 'google-maps-react';
import {API_ROOT} from '../../../../../baseUrls';
import {Button, TextField} from '@material-ui/core';
import withGoogleMaps from '../../../../organisms/with-google-maps/withGoogleMaps';
import Location from "../../../../util/common/Location";

class FileMap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      address: '',
      enteredLatitude: props.location?.latitude || 40.7484405,
      enteredLongitude: props.location?.longitude || -73.9878584,
      location: props.location
    };
    this.map = null;
  }

  mapLoaded(mapProps, map) {
    this.map = map;
  }

  setLocation(location){
    this.setState({location:location, enteredLatitude: location.latitude, enteredLongitude: location.longitude});
    this.map.setCenter({lat: location.latitude, lng: location.longitude});
    this.props.updateLocation(location)
  }
  geolocate() {
    const addressEncoded = encodeURI(this.state.address);
    fetch(`${API_ROOT}/google-geocode?address=${addressEncoded}`, {
      credentials: 'include',
    })
    .then(resp => resp.json())
    .then(data => {
      if (data.status.toLowerCase() === 'ok') {
        const result = data.results.pop();
        const latitude = result.geometry.location.lat;
        const longitude = result.geometry.location.lng;

        let locality=null;
        let region=null;
        let country=null;
        for (const addressItem of result.address_components) {
          if (addressItem.types.includes('country')) {
            country = addressItem.long_name
          }
          if (addressItem.types.includes('administrative_area_level_1')) {
            region = addressItem.long_name
          }
          if (addressItem.types.includes('locality')) {
            locality = addressItem.long_name
          }
        }
        this.setLocation({latitude, longitude, locality, region, country})
      } else {
        // console.error('Geocoding API error: ', data)
      }
    })
    .catch((ignore) => {
      // console.error('Geocoding API error: ', e)
    });
  }

  recalculateLatLng(latitude, longitude) {
    this.setState({enteredLatitude: latitude, enteredLongitude: longitude})
    fetch(`${API_ROOT}/google-geocode?latlng=${latitude},${longitude}`, {
      credentials: 'include',
    })
    .then(resp => resp.json())
    .then(data => {
      if (data.status.toLowerCase() === 'ok') {
        let locality=null;
        let region=null;
        let country=null;
        for (const addressItem of data.results[0].address_components) {
          if (addressItem.types.includes('country')) {
            country = addressItem.long_name
          }
          if (addressItem.types.includes('administrative_area_level_1')) {
            region = addressItem.long_name
          }
          if (addressItem.types.includes('locality')) {
            locality = addressItem.long_name
          }
        }

        this.setLocation({latitude, longitude, locality, region, country})
      } else {
        console.error('Geocoding API error: ', data)
      }
    })
  }

  commitEnteredLatLng() {
    let latitude = +this.state.enteredLatitude
    if (this.state.enteredLatitude === '' || !isFinite(latitude)) {
      latitude = this.state.location?.latitude || 40.7484405
    }
    let longitude = +this.state.enteredLongitude
    if (this.state.enteredLongitude === '' || !isFinite(longitude)) {
      longitude = this.state.location?.longitude || -73.9878584
    }
    this.map.setCenter({lat: latitude, lng: longitude})
    this.recalculateLatLng(latitude, longitude)
  }

  handleDragEnd(t, map, coord) {
    this.recalculateLatLng(coord.latLng.lat(), coord.latLng.lng())
  }

  render() {
    const isDraggable = !!this.props.isDraggable
    const lat = this.state.enteredLatitude
    const lng = this.state.enteredLongitude

    return (
      <div id={this.props.id} style={{position: 'relative', display: 'flex', flexWrap:'wrap', gap: '0.5rem 1rem', width: "100%"}}>
        { isDraggable ?
          <div style={{
            display: 'flex',
            flexDirection:'column',
            gap: '0.5rem',
            flex: 1,
            minWidth: `min(${this.props.size === "large" ? "24" : "14" }rem, 100%)`,
            height: 'fit-content',
          }}>
            <div key="display" style={{display: 'flex', flexDirection:"column", gap: '0.5rem', flex:1}}>
              <div style={{fontSize:"12px", color:"rgba(0,0,0,0.54)"}}>Location</div>
              <Location id="locationDisplay" location={this.state.location} />
            </div>
            <div key="address" style={{display: 'flex', gap: '0.5rem', flex:1}}>
              <TextField
                size="small"
                variant="outlined"
                placeholder="Search by address"
                margin="none"
                value={this.state.address}
                onChange={e => {
                  this.setState({address: e.target.value});
                }}
                onKeyDown={e => {
                  if (e.key === 'Enter') {
                    this.geolocate();
                  }
                }}
                style={{width: "100%"}}
              />
              <Button variant="outlined" onClick={this.geolocate.bind(this)}>Find</Button>
            </div>
            <div key="latlng" style={{display: 'flex', gap: '0.5rem', flex:1}}>
              <TextField
                size="small"
                fullWidth
                margin="none"
                variant="outlined"
                label="Latitude"
                value={this.state.enteredLatitude}
                onChange={e => this.setState({ enteredLatitude: e.target.value })}
                onKeyDown={e => {
                  if (e.key === 'Enter') {
                    this.commitEnteredLatLng()
                  }
                }}
                onBlur={() => this.commitEnteredLatLng()}
              />
              <TextField
                size="small"
                fullWidth
                margin="none"
                variant="outlined"
                label="Longitude"
                value={this.state.enteredLongitude}
                onChange={e => this.setState({ enteredLongitude: e.target.value })}
                onKeyDown={e => {
                  if (e.key === 'Enter') {
                    this.commitEnteredLatLng()
                  }
                }}
                onBlur={() => this.commitEnteredLatLng()}
              />
            </div>
          </div>
          : null
        }
        <div id="googMap" style={{
          height: '400px',
          minHeight:'300px',
          position:'relative',
          flex:1,
          // minWidth:"calc(min(14rem, 100%))"
          minWidth: `min(${this.props.size === "large" ? "24" : "14" }rem, 100%)`,
        }}>
          <Map
            google={window.google}
            onReady={this.mapLoaded.bind(this)}
            zoom={14}
            containerStyle={{
              height: '400px',
              minHeight:'300px',
              position:'relative',
              flex:1,
              // minWidth:"calc(min(14rem, 100%))"
              minWidth: `min(${this.props.size === "large" ? "24" : "14" }rem, 100%)`,
            }}
            initialCenter={{lat, lng}}
          >
            <Marker
              onClick={() => alert('click')}
              name={'Current location'}
              position={{lat, lng}}
              draggable={isDraggable}
              onDragend={this.handleDragEnd.bind(this)}
            />
          </Map>
        </div>
      </div>
    )
  }
}

export default withGoogleMaps(FileMap);
